

$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });

  $('.lang_switcher ul li').click(function(){
    var lang = $(this).data('lang');
    $('.lang_switcher ul li').removeClass('selected');
    $(this).addClass('selected');
    $('.wrapper').removeClass('jp');
    $('.wrapper').removeClass('en');
    $('.wrapper').addClass(lang);
  });

  $('.header_menu_btn').click(function(){
    $('header').toggleClass('open');
  });

  $('.header_menu a').click(function(){
    $('header').removeClass('open');
  });

  var mainSwiper = new Swiper('#slider', {
    // パラメーター
    loop: true,
    slidesPerView: 4,
    speed:4000,
    allowTouchMove: false,
    autoplay: {delay: 0},
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween:20
      }
    }
  });

  $(window).resize(function(){
      mainSwiper.autoplay.paused = false;
      mainSwiper.autoplay.start();
  });

  $('.swiper-slide').click(function(){
    var modalImg = $(this).html();
    $('body').append('<div class="modal_bg flex flex_middle flex_center"><div class="modal_img">'+modalImg+'</div></div>');
    $('body').css('overflow','hidden');

    $('.modal_bg').click(function(){
      $(this).remove();
      $('body').css('overflow','auto');
    });
  });

});
